import * as S from './styles';

interface SceneLinkToggleProps {
	sceneName: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
}

const SceneLinkToggle = ({ sceneName, checked, onChange }: SceneLinkToggleProps) => {
	const handleContainerClick = () => {
		onChange(!checked);
	};

	const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.stopPropagation();
		onChange(e.target.checked);
	};

	return (
		<S.Container checked={checked} onClick={handleContainerClick}>
			<S.Checkbox
				type="checkbox"
				checked={checked}
				onChange={handleCheckboxChange}
				id="scene-link-toggle"
				onClick={(e) => e.stopPropagation()}
			/>
			<S.Label htmlFor="scene-link-toggle">
				Link design system to <S.SceneName>{sceneName}</S.SceneName>
			</S.Label>
		</S.Container>
	);
};

export default SceneLinkToggle;
